var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"relative hidden lg:block text-indigo-700 text-xs sm:text-base md:text-lg"},[_vm._t("title")],2),_c('div',{staticClass:"flex text-indigo-500 text-xs sm:text-sm md:text-base"},[_vm._t("info")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }